import { AppOnboardingSurvey } from '@frontend/App/App.OnboardingSurvey';

export function AppOnboarding() {
  return (
    <div className="flex min-h-screen">
      {/* Sidebar */}
      <div
        className="w-80 border bg-white p-10 flex flex-col sticky top-0 rounded-xl"
        style={{
          borderColor: 'var(--border)',
          background:
            'linear-gradient(0deg, rgba(159, 244, 130, 0.32) 0%, rgba(159, 244, 130, 0) 28%)',
          marginTop: '12px',
          marginBottom: '12px',
          marginLeft: '12px',
          marginRight: '12px',
          height: 'calc(100vh - 24px)',
        }}
      >
        <div className="flex-1 flex flex-col justify-center gap-4">
          <img
            src="/assets/qb-logo-icon.svg"
            alt="Question Base"
            className="h-10 w-10 flex-shrink-0"
          />
          <h1
            className="text-4xl font-bold text-slate-900 leading-tight tracking-tight"
            style={{ fontSize: '32px' }}
          >
            Welcome to Question Base
          </h1>
          <p
            className="text-slate-600 leading-relaxed"
            style={{ fontSize: '13px' }}
          >
            Your Answer Agent for Slack
          </p>
        </div>
      </div>

      {/* Main content */}
      <div className="flex-1 flex items-center justify-center px-8 py-12">
        <div className="w-full max-w-3xl">
          <AppOnboardingSurvey />
        </div>
      </div>
    </div>
  );
}
